import { render, staticRenderFns } from "./EFormDocentes.vue?vue&type=template&id=011b000e&scoped=true"
import script from "./EFormDocentes.vue?vue&type=script&lang=js"
export * from "./EFormDocentes.vue?vue&type=script&lang=js"
import style0 from "./EFormDocentes.vue?vue&type=style&index=0&id=011b000e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011b000e",
  null
  
)

export default component.exports